import React from 'react';
import { Tag } from 'antd';
import { PipelineStatus } from '../../../core/modules/pipelines/pipelines.model';
import { PIPELINE_STATUS_COLOR, PIPELINE_STATUS_LABEL } from '../utils/statusColors';

interface IStatusBadgeProps {
  status: PipelineStatus;
}

const StatusBadge: React.FC<IStatusBadgeProps> = ({ status }) => (
  <Tag color={PIPELINE_STATUS_COLOR[status] ?? 'default'}>
    {PIPELINE_STATUS_LABEL[status] ?? status}
  </Tag>
);

export default StatusBadge;
